module.exports = __webpack_public_path__ + "img/gp_promotion_female_2.7ddbb20c.png";